import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import applyForm from './applyForm.vue';
import ticketForm from './ticketForm.vue';
import ticketFollowUpDialog from './components/ticketFollowUpDialog.vue';
import ticketAssignDialog from './components/ticketAssignDialog.vue';
import quotationAssignDialog from './components/quotationAssignDialog.vue';
import quotationApprovalDrawer from './components/quotationApprovalDrawer.vue';
import FollowUpDialog from './components/FollowUpDialog.vue';
import { getCustomerList } from '@/views/cardSystem/customer/api/index';
import { formatApprover } from './defaultForms';
import { getMyApprovalProjectList, getMyApprovalMallList, getMyApprovalPrintingList, getMyAuditQuotationList, getMyAuditQuotationBindList, searchUserList, getProjectTicketSelect, getProjectTicketMyAuditList } from '../api';
export default {
  components: {
    applyForm: applyForm,
    ticketForm: ticketForm,
    ticketFollowUpDialog: ticketFollowUpDialog,
    ticketAssignDialog: ticketAssignDialog,
    quotationAssignDialog: quotationAssignDialog,
    quotationApprovalDrawer: quotationApprovalDrawer,
    FollowUpDialog: FollowUpDialog
  },
  props: {
    reviewProjectCount: {
      type: Number,
      default: 0
    },
    reviewMallCount: {
      type: Number,
      default: 0
    },
    reviewBiddingCount: {
      type: Number,
      default: 0
    },
    reviewPrintingCount: {
      type: Number,
      default: 0
    },
    reviewTicketCount: {
      type: Number,
      default: 0
    },
    reviewQuotationCount: {
      type: Number,
      default: 0
    },
    reviewQuotationBindCount: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      tabActiveName: '1',
      companyList: [],
      // 人员下拉远程搜索：按下拉字段隔离选项，已选项缓存记录 id→选项（换关键字后已选标签不退化）
      personOptions: {},
      personOptionCache: {},
      personLoading: false,
      searchForm: {
        number: '',
        item_number: '',
        user_id: '',
        customer_id: null,
        project_name: '',
        project_type: [],
        type: [],
        expedited_not: null,
        urgent_printing: null,
        pageSize: 20,
        page: 1
      },
      listData: [],
      listPages: {
        currentPage: 1,
        totalCount: 0
      },
      applyFormVisible: false,
      applyFormType: 'view',
      selectedId: null,
      selectedItemId: null,
      selectedProjectType: null,
      selectedProjectStatus: null,
      drawerTitle: '装修&项目交付申请',
      followUpVisible: false,
      followUpProjectId: null,
      followUpTaskId: null,
      ticketSearchForm: {
        work_order_no: '',
        title: '',
        second_category_id: [],
        item: '',
        start_created_at: '',
        end_created_at: '',
        page: 1,
        pageSize: 20
      },
      ticketCreatedAtTime: [],
      ticketListData: [],
      ticketListPages: {
        currentPage: 1,
        totalCount: 0
      },
      ticketCategoryTree: [],
      ticketDrawerVisible: false,
      ticketFormId: null,
      ticketFormType: 'view',
      ticketFormCustomerName: '',
      ticketFollowUpVisible: false,
      ticketAssignVisible: false,
      quotationAssignVisible: false,
      quotationDrawerVisible: false,
      quotationSearchForm: {
        number: '',
        user_id: '',
        customer_id: null,
        project_name: '',
        pageSize: 20,
        page: 1
      },
      quotationListData: [],
      quotationListPages: {
        currentPage: 1,
        totalCount: 0
      }
    };
  },
  created: function created() {
    var _this = this;
    var tabList = [{
      name: '1',
      permission: '/user/project-delivery/my-audit-project'
    }, {
      name: '2',
      permission: '/user/project-delivery/my-audit-mall'
    }, {
      name: '4',
      permission: '/user/project-delivery/my-audit-printing'
    }, {
      name: '5',
      permission: '/user/project-ticket/my-audit'
    }, {
      name: '6',
      permission: '/user/project-delivery/my-audit-quotation'
    }, {
      name: '7',
      permission: '/user/project-delivery/my-audit-quotation-bind'
    }];
    var firstVisibleTab = tabList.find(function (item) {
      return _this.$hasBtnRoles(item.permission);
    });
    if (!firstVisibleTab) return;
    this.tabActiveName = firstVisibleTab.name;
    this.getCompanyList();
    // 初始预载人员下拉默认选项（空关键词返回默认列表）
    this.searchSubmitter('');
    this.searchQuotationSubmitter('');
    if (['6', '7'].includes(this.tabActiveName)) {
      this.getQuotationList();
      return;
    }
    this.getlist();
    if (this.tabActiveName === '5') {
      this.initTicketTab();
    }
  },
  methods: {
    formatApprover: formatApprover,
    // 当前审批节点：approver 里 status=1 的那条；行上没有 approver 数组时退回平铺字段
    currentApprover: function currentApprover(row) {
      var pending = (row.approver || []).find(function (item) {
        return String(item.status) === '1';
      });
      return pending || {
        approver_name: row.approver_name,
        approver_type: row.approver_type
      };
    },
    approveButtonText: function approveButtonText(row) {
      var approver = this.currentApprover(row);
      // approver 数组里是裸字段 type，列表平铺字段是 approver_type
      var approverType = approver.approver_type != null ? approver.approver_type : approver.type;
      if (String(approverType) === '1') return '初审';
      if (String(approverType) === '2') return '复审';
      return '审批';
    },
    getPrintingSheetValues: function getPrintingSheetValues(row) {
      var values = [];
      if (Number(row.expedited_not) === 2) values.push('加急设计');
      if (Number(row.need_printing) === 1) {
        values.push(Number(row.urgent_printing) === 2 ? '需要印刷-加急' : '需要印刷');
      } else if (Number(row.need_printing) === 2) {
        values.push('不需要印刷');
      }
      if (Number(row.printing_quantity) > 0) {
        values.push("\u6570\u91CF\uFF1A".concat(row.printing_quantity));
      }
      return values;
    },
    handleTabClick: function handleTabClick(tab) {
      if (tab.name === this.tabActiveName) return;
      this.tabActiveName = tab.name;
      if (['6', '7'].includes(tab.name)) {
        this.quotationSearchForm = {
          number: '',
          user_id: '',
          customer_id: null,
          project_name: '',
          pageSize: 20,
          page: 1
        };
        this.getQuotationList();
        this.$emit('countChange', {
          tabKey: this.getTabKey(tab.name),
          searchForm: null
        });
        return;
      }
      this.searchForm = {
        number: '',
        item_number: '',
        user_id: '',
        customer_id: null,
        project_name: '',
        project_type: [],
        type: [],
        expedited_not: null,
        urgent_printing: null,
        pageSize: 20,
        page: 1
      };
      if (tab.name === '5') {
        this.initTicketTab();
        this.$emit('countChange', {
          tabKey: 'ticket',
          searchForm: null
        });
        return;
      }
      this.getlist();
      this.$emit('countChange', {
        tabKey: this.getTabKey(tab.name),
        searchForm: null
      });
    },
    getTabKey: function getTabKey(tabName) {
      var map = {
        1: 'project',
        2: 'mall',
        4: 'card',
        5: 'ticket',
        6: 'quotation',
        7: 'quotationBind'
      };
      return map[tabName] || 'project';
    },
    // 人员下拉通用远程搜索：结果按字段存进 personOptions，已选项从缓存回填
    searchPerson: function searchPerson(keyword, field, valueGetter) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var kw, res, list, selected, picked;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              kw = (keyword || '').trim();
              _this2.personLoading = true;
              _context.p = 1;
              _context.n = 2;
              return searchUserList({
                keyword: kw
              });
            case 2:
              res = _context.v;
              list = res.data || [];
              list.forEach(function (item) {
                _this2.personOptionCache[String(item.id)] = item;
              });
              // 结果并入已选项：换关键字会销毁旧 option，已选标签需继续有数据可查
              selected = valueGetter();
              if (!Array.isArray(selected)) {
                selected = selected === undefined || selected === null || selected === '' ? [] : [selected];
              }
              picked = selected.filter(function (id) {
                return !list.some(function (item) {
                  return String(item.id) === String(id);
                });
              }).map(function (id) {
                return _this2.personOptionCache[String(id)];
              }).filter(Boolean);
              _this2.$set(_this2.personOptions, field, picked.concat(list));
            case 3:
              _context.p = 3;
              _this2.personLoading = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 3, 4]]);
      }))();
    },
    // 提交人（列表筛选）
    searchSubmitter: function searchSubmitter(keyword) {
      var _this3 = this;
      return this.searchPerson(keyword, 'submitter', function () {
        return _this3.searchForm.user_id;
      });
    },
    // 提交人（报价单配置）
    searchQuotationSubmitter: function searchQuotationSubmitter(keyword) {
      var _this4 = this;
      return this.searchPerson(keyword, 'quotationSubmitter', function () {
        return _this4.quotationSearchForm.user_id;
      });
    },
    openFollowUp: function openFollowUp(row) {
      this.followUpProjectId = this.tabActiveName === '1' ? row.id : row.project_id;
      this.followUpTaskId = this.tabActiveName === '1' ? null : row.item_id;
      this.followUpVisible = true;
    },
    // 跟进提交成功：报价单审核/分发的列表数据独立，需按 tab 选择刷新目标；
    // 跟进不改变待办数量，因此只刷列表，不联动角标统计
    handleFollowUpSuccess: function handleFollowUpSuccess() {
      if (['6', '7'].includes(this.tabActiveName)) {
        this.getQuotationList();
      } else {
        this.getlist();
      }
    },
    getCompanyList: function getCompanyList(val) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getCustomerList({
                page_size: 200,
                name: val || '',
                is_delete: 0
              });
            case 1:
              res = _context2.v;
              _this5.companyList = res.data.list;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getlist: function getlist() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var apiFn, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!['5', '6', '7'].includes(_this6.tabActiveName)) {
                _context3.n = 1;
                break;
              }
              _this6.listData = [];
              _this6.listPages = {
                currentPage: 1,
                totalCount: 0
              };
              return _context3.a(2);
            case 1:
              apiFn = getMyApprovalProjectList;
              if (_this6.tabActiveName === '1') {
                apiFn = getMyApprovalProjectList;
              } else if (_this6.tabActiveName === '2') {
                apiFn = getMyApprovalMallList;
              } else if (_this6.tabActiveName === '4') {
                apiFn = getMyApprovalPrintingList;
              }
              _context3.n = 2;
              return apiFn(_this6.searchForm);
            case 2:
              res = _context3.v;
              _this6.listData = res.data.data;
              _this6.listPages = res.pages;
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    // 报价单审核/分发列表（两个 tab 共用筛选与表格结构，接口不同）
    getQuotationList: function getQuotationList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var apiFn, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              apiFn = _this7.tabActiveName === '7' ? getMyAuditQuotationBindList : getMyAuditQuotationList;
              _context4.n = 1;
              return apiFn(_this7.quotationSearchForm);
            case 1:
              res = _context4.v;
              _this7.quotationListData = res.data && res.data.data || [];
              _this7.quotationListPages = res.pages || {
                currentPage: 1,
                totalCount: 0
              };
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    // 报价单审批/分配负责人完成后：刷新列表并联动当前 tab 的角标统计
    refreshQuotationListAndCount: function refreshQuotationListAndCount() {
      this.getQuotationList();
      this.$emit('countChange', {
        tabKey: this.getTabKey(this.tabActiveName),
        searchForm: _objectSpread({}, this.quotationSearchForm)
      });
    },
    quotationResetList: function quotationResetList() {
      this.quotationSearchForm.page = 1;
      this.getQuotationList();
      this.$emit('countChange', {
        tabKey: this.getTabKey(this.tabActiveName),
        searchForm: _objectSpread({}, this.quotationSearchForm)
      });
    },
    handleQuotationPageChange: function handleQuotationPageChange(page) {
      this.quotationSearchForm.page = page;
      this.getQuotationList();
      var dom = document.getElementById('quotationSearchDom');
      dom && dom.scrollIntoView();
    },
    quotationSizeChange: function quotationSizeChange(size) {
      this.quotationSearchForm.pageSize = size;
      this.quotationSearchForm.page = 1;
      this.getQuotationList();
    },
    initTicketTab: function initTicketTab() {
      if (!this.ticketCategoryTree.length) {
        this.getTicketCategoryTree();
      }
      this.getTicketList();
    },
    getTicketCategoryTree: function getTicketCategoryTree() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return getProjectTicketSelect();
            case 1:
              res = _context5.v;
              _this8.ticketCategoryTree = res.data && res.data.tree || [];
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getTicketList: function getTicketList() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var secondCategoryIds, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              // cascader 多选值为路径数组（[一级id, 二级id]），接口需要叶子（二级）id 数组
              secondCategoryIds = _this9.ticketSearchForm.second_category_id.map(function (path) {
                return path.length ? path[path.length - 1] : null;
              });
              _context6.n = 1;
              return getProjectTicketMyAuditList({
                work_order_no: _this9.ticketSearchForm.work_order_no,
                title: _this9.ticketSearchForm.title,
                second_category_id: secondCategoryIds,
                item: _this9.ticketSearchForm.item,
                start_created_at: _this9.ticketSearchForm.start_created_at,
                end_created_at: _this9.ticketSearchForm.end_created_at,
                page: _this9.ticketSearchForm.page,
                pageSize: _this9.ticketSearchForm.pageSize
              });
            case 1:
              res = _context6.v;
              _this9.ticketListData = res.data.data || [];
              _this9.ticketListPages = res.pages || {
                currentPage: 1,
                totalCount: 0
              };
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    ticketResetList: function ticketResetList() {
      this.ticketSearchForm.page = 1;
      this.getTicketList();
      this.emitTicketCountChange();
    },
    // 咨询工单搜索后联动角标：cascader 取叶子节点 id，与列表请求口径一致
    emitTicketCountChange: function emitTicketCountChange() {
      var secondCategoryIds = this.ticketSearchForm.second_category_id.map(function (path) {
        return path.length ? path[path.length - 1] : null;
      });
      this.$emit('countChange', {
        tabKey: 'ticket',
        searchForm: {
          work_order_no: this.ticketSearchForm.work_order_no,
          title: this.ticketSearchForm.title,
          second_category_id: secondCategoryIds,
          item: this.ticketSearchForm.item,
          start_created_at: this.ticketSearchForm.start_created_at,
          end_created_at: this.ticketSearchForm.end_created_at,
          page: 1,
          pageSize: this.ticketSearchForm.pageSize
        }
      });
    },
    handleTicketPageChange: function handleTicketPageChange(page) {
      this.ticketSearchForm.page = page;
      this.getTicketList();
      var dom = document.getElementById('ticketSearchDom');
      dom.scrollIntoView();
    },
    ticketSizeChange: function ticketSizeChange(size) {
      this.ticketSearchForm.pageSize = size;
      this.ticketSearchForm.page = 1;
      this.getTicketList();
    },
    changeTicketCreatedAtTime: function changeTicketCreatedAtTime(val) {
      this.ticketSearchForm.start_created_at = val ? val[0] : '';
      this.ticketSearchForm.end_created_at = val ? val[1] : '';
    },
    viewTicketDetail: function viewTicketDetail(row) {
      this.ticketFormId = row.id;
      this.ticketFormType = 'view';
      this.ticketFormCustomerName = row.customer_info && row.customer_info.company_name || '';
      this.ticketDrawerVisible = true;
    },
    handleTicketFormSuccess: function handleTicketFormSuccess() {
      this.ticketDrawerVisible = false;
      this.getTicketList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.getlist();
      var dom = document.getElementById('searchDom');
      dom.scrollIntoView();
    },
    sizeChange: function sizeChange(size) {
      this.searchForm.pageSize = size;
      this.searchForm.page = 1;
      this.getlist();
    },
    resetList: function resetList() {
      this.searchForm.page = 1;
      this.getlist();
      this.$emit('countChange', {
        tabKey: this.getTabKey(this.tabActiveName),
        searchForm: _objectSpread({}, this.searchForm)
      });
    },
    handleClose: function handleClose() {
      if (['6', '7'].includes(this.tabActiveName)) {
        this.refreshQuotationListAndCount();
      } else {
        this.getlist();
        this.$emit('countChange', {
          tabKey: this.getTabKey(this.tabActiveName),
          searchForm: _objectSpread({}, this.searchForm)
        });
      }
    },
    viewDetail: function viewDetail(row) {
      this.selectedId = this.tabActiveName === '1' ? row.id : row.project_id;
      this.selectedItemId = null;
      this.selectedProjectType = row.project_type;
      this.selectedProjectStatus = this.getProjectStatus(row);
      this.applyFormType = 'view';
      if (this.tabActiveName == '1') {
        this.drawerTitle = '装修&项目交付申请（项目ID：' + row.number + '）';
      } else {
        this.drawerTitle = '装修&项目交付申请（任务ID：' + row.number + '）';
      }
      this.applyFormVisible = true;
    },
    approve: function approve(row) {
      // 报价单审批使用独立的全屏抽屉，其余 tab 仍走 applyForm
      if (this.tabActiveName == '6') {
        this.selectedId = row.project_id;
        this.selectedItemId = null;
        this.selectedProjectType = row.project_type;
        this.selectedProjectStatus = this.getProjectStatus(row);
        this.drawerTitle = '装修&项目交付申请（任务ID：' + row.number + '）';
        this.quotationDrawerVisible = true;
        return;
      }
      this.selectedId = this.tabActiveName === '1' ? row.id : row.project_id;
      this.selectedItemId = this.tabActiveName !== '1' ? row.item_id : null;
      this.selectedProjectType = row.project_type;
      this.selectedProjectStatus = this.getProjectStatus(row);
      this.applyFormType = 'approve';
      if (this.tabActiveName == '1') {
        this.drawerTitle = '装修&项目交付申请（项目ID：' + row.number + '）';
      } else {
        this.drawerTitle = '装修&项目交付申请（任务ID：' + row.number + '）';
      }
      this.applyFormVisible = true;
    },
    getProjectStatus: function getProjectStatus(row) {
      return row.status;
    },
    openTicketFollowUp: function openTicketFollowUp(row) {
      this.$refs.ticketFollowUpDialog.open(row.id);
    },
    openAssignDialog: function openAssignDialog(row) {
      this.$refs.ticketAssignDialog.open(row.id);
    },
    // 报价单分发-分配负责人弹窗
    openQuotationAssign: function openQuotationAssign(row) {
      this.$refs.quotationAssignDialog.open(row);
    },
    // 工单操作（跟进/分配负责人）成功：刷新列表并联动顶部/子tab角标计数
    handleTicketActionSuccess: function handleTicketActionSuccess() {
      this.getTicketList();
      this.$emit('countChange', {
        tabKey: 'ticket',
        searchForm: null
      });
    }
  }
};